// extracted by mini-css-extract-plugin
module.exports = {"card":"CardRecipe_card__1bGsH","title":"CardRecipe_title__ziiGc","extras":"CardRecipe_extras__3jpkR","img":"CardRecipe_img__2ZH4G"};